import { useLayoutEffect, useEffect } from "react";

/**
 * Prevent warning on SSR by falling back to useEffect when window is not defined
 * Source: https://github.com/ianstormtaylor/slate/pull/3262/files
 */
export const useIsomorphicLayoutEffect = typeof window !== "undefined" ? useLayoutEffect : useEffect;
